import { PeopleAltTwoTone } from "@mui/icons-material";

const PeopleAltIcon = () => {
  return <PeopleAltTwoTone />;
};

export default PeopleAltIcon;
